'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (a) {
  return typeof a;
} : function (a) {
  return a && 'function' == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? 'symbol' : typeof a;
};
(function (a) {
  'use strict';

  var b = function () {
    for (var d = arguments.length, c = Array(d), f = 0; f < d; f++) c[f] = arguments[f];
    var g = document.createElement('input');
    return 'object' === _typeof(c[0]) && (!0 === c[0].multiple && g.setAttribute('multiple', ''), void 0 !== c[0].accept && g.setAttribute('accept', c[0].accept)), g.setAttribute('type', 'file'), g.style.display = 'none', g.setAttribute('id', 'hidden-file'), document.body.appendChild(g), new Promise(function (h) {
      g.addEventListener('change', function () {
        h(g.files);
        var l = c[c.length - 1];
        'function' == typeof l && l(g.files), document.body.removeChild(g);
      });
      var j = document.createEvent('MouseEvents');
      j.initMouseEvent('click', !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), g.dispatchEvent(j);
    });
  };
  'function' == typeof define && define.amd ? define(function () {
    return b;
  }) : 'undefined' == typeof exports ? a.fileDialog = b : ('undefined' != typeof module && module.exports && (exports = module.exports = b), exports.fileDialog = b);
})(void 0);